import React from 'react';
import {navigate} from 'gatsby';
import PropTypes from 'prop-types';
import SliderSlick from 'react-slick';

import Slider from '../core/Slider';
import {BannerStyled} from './styles';
import {Hidden} from 'react-awesome-styled-grid';
import {fetchBanners} from '../../API/makers/adminBanners';
import {generateImageUrl} from '../../utils/productHelper';
import SkeletonSlider from '../core/Slider/SkeletonSlider';

export const SliderComponent = ({tagName, arrow}) => {
  const {banners} = fetchBanners(tagName);

  // new order banner position
  banners.sort((a, b) => a.banner_position - b.banner_position);

  const settings = {
    dots: false,
    infinite: true,
    centerPadding: '400px',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    adaptiveHeight: true,
    pauseOnHover: false,
    autoplaySpeed: 4500,
    rtl: false,
    arrows: arrow,
    responsive: [
      {
        breakpoint: 450,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <BannerStyled arrow={arrow}>
      <link
        rel="stylesheet"
        type="text/css"
        // charset="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      <Hidden xs>
        <SliderSlick {...settings}>
          {banners.length ? (
            banners.map(banner =>
              tagName !== 'collections-banner' ? (
                <Slider
                  key={banner.id || ''}
                  tag={tagName}
                  title={banner.title || ''}
                  image={generateImageUrl(banner.image_url || '')}
                  description={banner.description || ''}
                  titleButton={banner.title_button || ''}
                  onClick={banner.link ? () => navigate(`${banner.link}`) : ''}
                />
              ) : (
                <Slider
                  key={banner.id || ''}
                  tag={tagName}
                  image={generateImageUrl(banner.image_url || '')}
                  // onClick={banner.link ? () => navigate(`${banner.link}`) : ''}
                />
              )
            )
          ) : (
            <SkeletonSlider tag={tagName} />
          )}
        </SliderSlick>
      </Hidden>
      <Hidden sm md lg xl>
        <SliderSlick {...settings}>
          {banners.length ? (
            banners.map(banner =>
              tagName !== 'collections-banner' ? (
                <Slider
                  key={banner.id}
                  tag={tagName}
                  title={banner.title}
                  description={banner.description}
                  image={generateImageUrl(banner.mobile_url)}
                  titleButton={banner.title_button}
                  onClick={() => navigate(`${banner.link}`)}
                />
              ) : (
                <Slider
                  key={banner.id || ''}
                  tag={tagName}
                  image={generateImageUrl(banner.mobile_url || '')}
                  // onClick={banner.link ? () => navigate(`${banner.link}`) : ''}
                />
              )
            )
          ) : (
            <SkeletonSlider tag={tagName} />
          )}
        </SliderSlick>
      </Hidden>
    </BannerStyled>
  );
};

export default SliderComponent;

SliderComponent.propTypes = {
  tagName: PropTypes.string,
  arrow: PropTypes.bool,
};
